module.exports = __webpack_public_path__ + "static/media/Food-2.eb106863.png";